import axios from "@/plugins/axios";

let url = "/api/v1/shop/stores";

export default {
    getBoilerplates(data){
        return axios.get(url, data).then(result => result.data);
    },
    getStore(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    }
}
